import { c as _c } from "react/compiler-runtime";
import React, { useId } from "react";
import styles from "./RadioButtons.module.scss";
export const RadioButton: React.FC<{
  selected: boolean;
  name: string;
  title: string;
  disabled?: boolean;
  required?: boolean;
  data_cy: string;
  dataId?: string;
  onSelect: () => void;
}> = t0 => {
  const $ = _c(17);
  const {
    selected,
    name,
    title,
    disabled,
    required,
    data_cy,
    dataId,
    onSelect
  } = t0;
  const uniqueId = useId();
  const uniqueName = `${name}-${uniqueId}`;
  const t1 = dataId || undefined;
  let t2;
  if ($[0] !== disabled || $[1] !== onSelect) {
    t2 = () => {
      if (disabled) {
        return;
      }
      onSelect();
    };
    $[0] = disabled;
    $[1] = onSelect;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data_cy || $[4] !== disabled || $[5] !== required || $[6] !== selected || $[7] !== t2 || $[8] !== title || $[9] !== uniqueName) {
    t3 = <input data-cy={data_cy} type="radio" name={uniqueName} title={title} className={styles.radiobutton} checked={selected} disabled={disabled} onChange={t2} required={required} />;
    $[3] = data_cy;
    $[4] = disabled;
    $[5] = required;
    $[6] = selected;
    $[7] = t2;
    $[8] = title;
    $[9] = uniqueName;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== title) {
    t4 = <div className={styles.radiobuttonlabel}>{title}</div>;
    $[11] = title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t4) {
    t5 = <label className={styles.radiobuttonwrapper} data-method-id={t1}>{t3}{t4}</label>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};